import { App } from "vue";

import resize from "@/directives/resize";
import { drag } from "@/directives/drag";
import { MouseMenuDirective } from "@howdyjs/mouse-menu";

/**
 * 注册全局自定义指令
 * @param app
 */
export function setupDirectives(app: App) {
  app.directive("resize", resize);
  app.directive("drag", drag);
  // 右键菜单
  const updated = MouseMenuDirective.mounted;
  app.directive("menu", Object.assign(MouseMenuDirective, { updated }));
}
